import React, { lazy, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { paginaVistaMeta } from "utils/metaPixel";
import { checkLocalStorageExpiration, clienteInfo } from "utils/DatosUsuarioLocalStorag";
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "swiper/css/bundle";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/demo.css";

import "views/Components/MODAL/localidas.css"
import "views/Pages/Svgviewa/isvg.css"
import "views/Pages/Svgviewa/class.css"
import "views/Pages/Svgviewa/svg.css"
import "views/Pages/Svgviewa/cultura.css"
import Indexflas from "../src/views/Pages/Flasdeticket" 
import { store } from "StoreRedux/store";
import { Provider } from 'react-redux';
import ToastViews from "views/Components/TOAST/toast";
import "./utils/tablas.css"
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
// Estilos globales (.eventos, .img-evento, .grid-item, .mt-n*...) que antes
// llegaban de rebote al importar Bingoparamsabs/Pdfwie de forma directa; ahora
// esas paginas cargan diferido, asi que se importan aca para no cambiar nada
// visualmente en la pagina principal.
import "views/Pages/Suscriptores/Pdfwie.css"
import Loadable from "views/Components/Loadable/index";
import AvisoPush from "components/AvisoPush";
import { reiniciarDescuentoAlCargar } from "utils/descuentoAlCargar";

// Recargar la pagina reinicia el descuento (si la direccion ya no trae ?desc=)
reiniciarDescuentoAlCargar();
// PERF: rutas que no son la pagina principal se cargan diferido (cada una en su
// propio archivo JS), asi el visitante de "/" no descarga su codigo.
const Compras = Loadable(lazy(() => import('Pages/Compras/index')))
const BingoViewtiparamsasb = Loadable(lazy(() => import("views/Pages/Suscriptores/Bingoparamsabs")))
const ResestPassword = Loadable(lazy(() => import("views/Pages/Susbcritorpage/Passwor")))
const LoginPage = Loadable(lazy(() => import("views/Pages/LoginPage")))
const AuthLayout = Loadable(lazy(() => import("layouts/Auth.js")))
const AdminLayout = Loadable(lazy(() => import("layouts/Admin.js")))
//const Indexflas = Loadable(lazy(() => import("../src/views/Pages/Flasdeticket")))

const Ventasnuevas = Loadable(lazy(() => import("views/Pages/VenderTiket.js/Ventas/index")))
const AsignarAsientoPage = Loadable(lazy(() => import("views/Pages/AsignarAsiento/index")))
const root = ReactDOM.createRoot(document.getElementById("root"));
// PERF: Handsontable (~700 KB) ya no se registra aca para toda la app; solo lo
// usan las tablas del admin -> ver views/Forms/handsontableSetup.js

// Pixel de Meta: PageView en cada cambio de pagina (React no recarga). Apagado sin META_PIXEL_ID en el
// backend o sin permiso de cookies; nunca en el panel (ver utils/metaPixel.js).
function RastreoMeta() {
  const location = useLocation();
  useEffect(() => { paginaVistaMeta(); }, [location.pathname]);
  return null;
}

// Una direccion con solo un codigo (ej. /4K93VK, como la que se pone en un aviso push) abre ese concierto: /?evento=4K93VK.
// Cualquier otra direccion desconocida vuelve al inicio, como antes.
function RedirigirCodigoOInicio() {
  const location = useLocation();
  const m = location.pathname.match(/^\/([A-Za-z0-9]{4,12})\/?$/);
  return <Navigate to={m ? `/?evento=${m[1].toUpperCase()}` : "/"} replace />;
}

function ExternalRedirect(e) {

  window.location.href = `https://api.whatsapp.com/send?phone=593980009000&text=${e.e}`;
  return null; // No renderiza nada
}
function ElementoDicho() {
  let dato = window.location.protocol + "//" + window.location.host + "/admin";
  window.location.href = dato;
  return null;

 
}



root.render(
  <Provider store={store}>
    <BrowserRouter>
      <RastreoMeta />
      <AvisoPush />
      <Routes>
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth" element={<Navigate to="/admin" replace />} />

        
        <Route
          path="/admin/*"
          element={ <AdminLayout />}
        >
          
        </Route>
        <Route
          path="/compra/*"
          element={<Compras />}
        />
        <Route path="/asignar-asiento/:cedula/:token" element={<AsignarAsientoPage />} />
        <Route path="/bingo/:id" element={<BingoViewtiparamsasb />} />
        <Route path="/password/:id" element={<ResestPassword />} />
        <Route
          path="/Jessi"
          element={<ExternalRedirect e="Quiero participar en el concurso de Jessi Uribe" />}
        />
        <Route
          path="/Mofle"
          element={<ExternalRedirect e="Quiero comprar boletos para el show de La Mofle" />}
        />
        <Route path="/" element={<Indexflas />} />
        <Route path="*" element={<RedirigirCodigoOInicio />} />
      </Routes>
    </BrowserRouter>
    <ToastViews />
  </Provider>
);
